import React from 'react';
import { Box } from '@mui/material';

export default function UnreadDot({ visible = false, size = 8, sx = {} }) {
  if (!visible) return null;
  return (
    <Box
      aria-hidden
      data-testid="unread-dot"
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: '#f44336',
        boxShadow: '0 0 0 2px rgba(0,0,0,0.55)',
        pointerEvents: 'none',
        ...sx,
      }}
    />
  );
}
